<template>
  <div>
    <generic-container
      :title="$t('provider')"
      icon="users"
      :searchable="true"
      :show_plus="true"
      v-on:add="add"
      v-on:filter="filter"
    >
      <div class="ui three link cards">
        <div
          class="card"
          v-for="(item, index) in providers"
          v-bind:key="index"
          v-on:click="select_provider(item)"
        >
          <div class="content">
            <img
              class="right floated mini ui image"
              src="/images/icons/provider.png"
            />
            <div class="header">{{ item.name }}</div>
            <div class="meta">
              <span>{{
                item.create_date
                  | formatDate(enterprise_setup.simple_date_format)
              }}</span>
            </div>
            <p></p>
          </div>
        </div>
      </div>
    </generic-container>
    <template v-for="(mdl, index) in popup_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
        :provider="provider"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api, enterprise_setup } from "@/utils";
import { cloneDeep } from "lodash";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
// import ConfigureModal from "./ConfigureModal";
import ProviderModal from "./ProviderModal";

// @ is an alias to /src
export default {
  name: "Provider",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      providers: [],
      all_providers: [],
      provider: {},
      // configure_modal: ConfigureModal,
      popup_modals: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      this.popup_modals.push(ProviderModal);
    },
    succedded(provider) {
      let trgtIdx = this.providers.findIndex((n) => n.uuid == provider.uuid);
      if (trgtIdx == -1) {
        this.providers.push(provider);
      } else {
        this.providers.splice(trgtIdx, 1, provider);
      }
      this.destroy();
    },
    destroy() {
      // this.popup_modals = [];
      this.provider = {};
    },
    filter(filter) {
      // console.log(filter);
      if (filter == "") this.providers = cloneDeep(this.all_products);
      else
        this.providers = this.all_providers.filter((n) =>
          n.name.toUpperCase().includes(filter.toUpperCase()),
        );
    },
    select_provider(provider) {
      this.provider = provider;
      // this.$router.push({
      //   name: "ProviderView",
      //   query: { i: provider.uuid }
      // });
      this.popup_modals.push(ProviderModal);
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/provider/do-get-all")
      .then((providers) => {
        let _providers = providers.sort(function(a, b) {
          if (a.name > b.name) return 1;
          if (b.name > a.name) return -1;
          return 0;
        });
        this.providers = _providers;
        this.all_providers = cloneDeep(_providers);
      })
      .catch((err) => {
        vm.$alertify.error(JSON.stringify(err, null, 2));
      });
  },
  watch: {},
};
</script>
